import React, { FunctionComponent } from "react";
import styles from "./Checkbox.module.scss";

export interface ColorBoxWithLabelProps {
    color: string;
    className?: string;
}

export const ColorBoxWithLabel: FunctionComponent<ColorBoxWithLabelProps> = ({ color, children, className }) => {
    return (
        <div className={`${className ?? ""} ${styles.colorBoxWithLabel}`}>
            <div
                className="color-box"
                style={{
                    background: color
                }}
            ></div>
            <label>{children}</label>
        </div>
    );
};
